<template>
  <div class="custom-wrapper z-nopadd" :class="{active: visible}" v-if="Modal.isOpen">
    <div class="position: relative;">
      <!-- .custom-company-cooperation === ccc --> 
      <div class="ccc">
        <div class="ccc-box custom-item">
          <!-- 内容 -->

          <div class="custom-m-item">
            <div class="cmi-title">{{Modal.title || '合作医院'}}</div>
            <div class="cmi-more">更多<Icon type="ios-arrow-forward" /></div>
            <div class="cmi-brand">

              <template v-if="list.length">
                <div
                  class="cmi-brand-item"
                  v-for="(item, index) in list"
                  :key="'cmi-brand-' + index"
                >
                  <img :src="item.logo" v-if="item.logo" />
                  <img src="@assets/img/empty.png" v-else />
                </div>
              </template>
              <template v-else>
                <div
                  class="cmi-brand-item"
                  v-for="(item, index) in emptylist"
                  :key="'cmi-brand-empty-' + index"
                >
                  <img src="@assets/img/empty.png" /> 
                </div>
              </template>
            </div>
            <!-- <img src="@assets/img/template/company-component-cove-6.jpg" width="100%" /> -->
          </div>

          <!-- <img src="@assets/img/template/company-component-cove-7.jpg" width="100%" /> -->
        </div>
      </div> 
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";

export default {
  // 旗下品牌
  name: "custom-company-brand",
  model: {
    prop: "Modal",
    event: "sendModal"
  },
  props: {
    index: {
      type: Number,
      default: 0
    },
    Modal: {
      type: Object,
      default: function() {
        return {
          info: "旗下品牌",
          type: 6,
          isOpen: true,
          title: "旗下品牌"
        };
      }
    }
  },
  data() {
    return {
      visible: false,

      emptylist: [1, 1],
      list: [],
      pageSize: 3,
      pageIndex: 1,
      totalCount: 0
    };
  },
  watch: {
    activeIndex(val, oldVal) {
      // if (val !== this.index) this.visible = false;
    },
    Load(val, oldVal) {
      if (val) {
        this.init();
      }
    }
  },
  computed: {
    type() {
      return this.Modal.config.type;
    },
    ...mapGetters({
      company: "loginModule/getCompany",
      Load: "customCompanyModule/getLoad",
      activeIndex: "customCompanyModule/getActiveIndex"
    }),
    option() {
      return {
        CompId: this.company.id,
        PageSize: this.pageSize,
        PageIndex: this.pageIndex
      };
    }
  },
  created() {
    this.init();
  },
  methods: {
    ...mapMutations({
      setActiveIndex: "customCompanyModule/setActiveIndex"
    }),
    ...mapActions({
      getBrand: "companyModule/getBrand", 
    }),
    async init() { 
      let result = await this.getBrand(this.option);
      if (result) {
        result.items.map(c => {
          if (c.banner) {
            c.banner = JSON.parse(c.banner);
          }
          c.visible = false;
        });
        this.list = result.items;
        this.pageSize = result.pageSize;
        this.pageIndex = result.pageIndex;
        this.totalCount = result.totalCount;
      }
    },
    setVisible() {
      this.visible = !this.visible;
      this.setActiveIndex(this.index);
    },
    linkTo() {
      const link = location.origin + "/#/exhibition/index/brand/addbrand";
      window.open(link);
    }
  }, 
};
</script> 
<style scoped lang="scss">
.ccc {
  width: 100%;
  &-info {
    display: inline-block;
    padding-left: 40px;
    font-size: 14px;
    color: #808080;
  }
  &-box {
    font-size: 0;
    background-color: #fff;
    cursor: pointer;
    div {
      word-break: break-all;
    }
  }
  &-poptip {
    min-height: 60px;
    .cccp {
      &-title {
        padding: 20px 30px;
        font-size: 14px;
        color: #333;
        border-bottom: solid 1px #ddd;
      }
      &-link {
        position: absolute;
        right: 20px;
        top: 20px;
      }
      &-content {
        padding: 40px 50px;
        .addlink {
          border: dashed 1px #bfbfbf;
          text-align: center;
          color: #1890ff;
          &:hover {
            cursor: pointer;
          }
        }
      }
    }
  }
}
.ct {
  &-components {
    .ctc {
      &-title {
        padding: 10px 20px;
        font-size: 14px;
        color: #333;
      }
      &-group {
        padding: 0 20px 20px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
      }
      &-item {
        width: 95px;
        height: 60px;
        margin-bottom: 10px;
        background-color: #ebebeb;
        text-align: center;
        padding-top: 5px;
        cursor: pointer;
        .iconfont {
          font-size: 20px;
          color: #222;
        }
        &-txt {
          width: 100%;
          font-size: 12px;
          color: #222;
        }
      }
    }
  }
}
.custom-wrapper {
  &.z-nopadd {
    padding: 0 0 10px;
  }
  &:hover,
  &.active {
    .custom-item {
      border: 1px solid #1890ff;
    }
  }
}
</style>
